import { digger } from '@cbre/digger';
import { concatValuesBy, isMediaImage } from '@miq/utils';
import { of } from 'rxjs';
import { ReportRecord } from '../../../../models/report.model';
import { MapHandlerOptions } from '../../../../models/windward-blueprint.model';
import { getMediaInformation } from '../../templates-formatter.const';
import { sortAttributesByFieldId, sortAttributesFields } from '../../utils/argument-sorting';
import { displayFnWrapper, mapAndFormatDynamicValue } from '../../utils/dynamic-data-retrievers';
import { getDisclaimerByLocale } from '../common';

export function getPropertyNameRoute({ data }) {
  const entityRecord = Array.isArray(data) ? data[0] : data;
  return ['/records', 'property', digger(entityRecord, 'entity.id'), 'edit'];
}

export function displayFnWrapperArrayFlatter(record, _, addOnFactorArg) {
  const arrayValue: string[] = displayFnWrapper(record, _, addOnFactorArg) as string[];

  if (arrayValue == null) {
    return '-';
  }
  return Array.isArray(arrayValue) ? arrayValue.join(',') : arrayValue;
}

export const commonDisplayFunctions = {
  98: {
    // 98 - Primary Image
    displayFn: (record: ReportRecord) => {
      return record.associatedProperty
        ? record.associatedProperty.getMediaInformation()
        : record.data.getMediaInformation();
    },
  },
  99: {
    // 99 - Additional Image
    displayFn: (record: ReportRecord) => {
      const mediaData = record.associatedProperty
        ? record.associatedProperty.getMediaInformation()
        : record.data.getMediaInformation();
      return (mediaData || []).filter(media => {
        return isMediaImage(media);
      });
    },
  },
  27: {
    // 27 - Address (Legacy)
    displayFn: (record: ReportRecord, options, ...args) => {
      const finalArgs = sortAttributesByFieldId(options.locale, args, 27);
      const values = finalArgs.map(arg => mapAndFormatDynamicValue(record, arg));
      const recordPosition = digger(record, 'position') + '. ';
      return recordPosition + concatValuesBy('- ', ...values);
    },
  },
  349: {
    // 349 - Custom Address
    displayFn: (record: ReportRecord, options, ...args) => {
      const { displayFnArgumentsOrder } = options;
      const finalArgs = sortAttributesFields(args, displayFnArgumentsOrder);
      const values = finalArgs.map(arg => mapAndFormatDynamicValue(record, arg));
      return concatValuesBy(', ', ...values);
    },
    routeFn: getPropertyNameRoute,
  },
  536: {
    // 536 - Disclaimer (long & shortlist)
    displayFn: (_, options) => {
      return getDisclaimerByLocale(options.locale);
    },
  },
  263: {
    // 263 - floor plan image
    displayFn: (record: ReportRecord) => {
      return getMediaInformation(record);
    },
  },
  405: {
    // 405 - map image
    displayFn: (record: ReportRecord, options) => {
      const { reportId } = options;
      const edpRecordId = record.edpRecordId;
      return of([reportId, edpRecordId]);
    },
  },
  525: {
    // 525 - property details label
    displayFn: displayFnWrapper,
  },
  266: {
    // 266 - summary map
    displayFn: (_record: ReportRecord, options) => {
      const { reportId } = options;
      const edpRecordId = undefined;
      const mapOptions: MapHandlerOptions = {
        enableCache: true,
        isGroupByProperty: true,
        width: 1200,
        height: 810,
      };
      return of([reportId, edpRecordId, mapOptions]);
    },
  },
  406: {
    // 406 - Map URL
    displayFn: (record: ReportRecord) => {
      const MAP_LINK_URL = 'https://www.google.com/maps/search/?api=1&query=';
      const latitude = digger(record, 'data.postal_address.latitude');
      const longitude = digger(record, 'data.postal_address.longitude');
      if (latitude == null || longitude == null) {
        return '';
      }
      return encodeURI(`${MAP_LINK_URL}${latitude},${longitude}`);
    },
  },
  546: {
    // 546 - Quality Space Label
    displayFn: displayFnWrapper,
  },
  410: {
    // 410 - Number Of Workspaces Label
    displayFn: displayFnWrapper,
  },
  413: {
    // 413 - Space Type Label
    displayFn: displayFnWrapper,
  },
  545: {
    // 545 - Asking Rate Label
    displayFn: displayFnWrapper,
  },
};
